import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const ChargeTypes = styled.ul(() =>
  mq({
    marginTop: defaultTheme.spacing.xxl,
    '& > li': {
      border: `2px solid ${defaultTheme.border.color.mediumLightGray}`,
      padding: defaultTheme.spacing.xxl,
      marginTop: defaultTheme.spacing.l,
    },
  }),
);

export const CardLogoContainer = styled.span(() =>
  mq({
    display: 'inline-block',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const ToretaNavi = styled.ul(() =>
  mq({
    display: ['grid', 'grid', 'none', 'none'],
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: defaultTheme.spacing.s,
    marginTop: defaultTheme.spacing.xxl,
    '& > li:first-of-type': {
      gridColumn: '1 / 3',
    },
    '& > li': {
      textAlign: 'center',
      border: `1px solid ${defaultTheme.border.color.black}`,
      borderRadius: defaultTheme.border.radius.s,
      padding: defaultTheme.spacing.s,
    },
  }),
);

export const ToretaNaviButton = styled.button((props: { isWide: boolean }) =>
  mq({
    display: 'flex',
    flexDirection: props.isWide ? 'row' : 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    width: '100%',
  }),
);

export const ToretaNaviImage = styled.div((props: { isWide: boolean }) =>
  mq({
    textAlign: 'center',
    margin: props.isWide
      ? `0 ${defaultTheme.spacing.s} 0 0`
      : `0 0 ${defaultTheme.spacing.s} 0`,
    width: '48px',
    height: '48px',
  }),
);

export const ToretaNaviText = styled.span(() =>
  mq({
    display: 'inline-block',
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.m,
  }),
);

export const Note = styled.span((props: { num?: number }) =>
  mq({
    display: 'flex',
    fontSize: defaultTheme.font.size.xs,
    color: defaultTheme.text.gray,
    '&::before': {
      content: `"※${props.num || ''}"`,
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);

export const TextNoteToreta = styled(Note)(() =>
  mq({
    justifyContent: 'center',
  }),
);
